export const SERVER_URL = "https://e-store-server.onrender.com"
// https://e-store-server.onrender.com
